import React from 'react';
import './MessagesFloatButton.css';

const ChatBubbleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 6.5A3.5 3.5 0 018.5 3h7A3.5 3.5 0 0119 6.5v6A3.5 3.5 0 0115.5 16H10l-4.2 3.15c-.55.41-1.3-.02-1.3-.72V6.5z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path d="M8.5 8.5h7M8.5 11.5h4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const MessagesFloatButton = ({
  count = 0,
  pulse = false,
  onClick,
  ariaLabel = 'Open messages',
}) => {
  const displayCount = count > 99 ? '99+' : count;

  return (
    <button
      type="button"
      className={`messages-float-button${pulse ? ' is-pulse' : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <span className="messages-float-button__glow" aria-hidden="true" />
      <span className="messages-float-button__icon" aria-hidden="true">
        <ChatBubbleIcon />
      </span>
      {count > 0 && (
        <span className="messages-float-badge" aria-hidden="true">
          {displayCount}
        </span>
      )}
    </button>
  );
};

export default MessagesFloatButton;
